import axios from "axios";

var baseURL = "https://rechner.waizmannpro.de";

if (
  window.location.hostname == "localhost" ||
  window.location.hostname == "loc.prorechner.de"
) {
  baseURL = "https://loc.prorechner.d";
}

if (window.location.hostname == "/rechner.waizmannpro.de") {
  baseURL = "https://rechner.waizmannpro.de";
}

const http = axios.create({
  baseURL: baseURL,
  withCredentials: true,
  headers: {
    // Authorization: "sdZdfcaeqwsc9jsd189asddsa219275asmygvlwdsjasd9a", // Achte auf das Leerzeichen nach 'Bearer'
    "Content-Type": "application/json",
  },
});

export default http;
